export const TIPO_USUARIO_LABELS: Record<string, string> = {
  Medico: 'Médico',
  SecretariaDoMedico: 'Secretária do Médico',
  SecretariaDoAmbulatorio: 'Secretária Ambulatório',
  SecretariaDoAgendamento: 'Secretária Agendamento',
  UsuarioBackoffice: 'Usuário Backoffice',
}
